import './BulkEditModal.scss';

import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';

import { DropdownModal, PopoverPosition } from '../';
import React, { PropsWithChildren } from 'react';

export type BulkEditModalProps = PropsWithChildren & {
	className?: string;
	getPopupContainer?: (trigger: HTMLElement) => HTMLElement;
	onCancel?: () => void;
	onOk?: () => void;
	onReset?: () => void;
	disabled?: boolean;
	targetNode?: HTMLElement | null;
	popoverPosition?: PopoverPosition;
	selectedCount: number;
	typeLabel: string;
};

export const BulkEditModal: React.FC<BulkEditModalProps> = ({
	children,
	getPopupContainer,
	className,
	disabled,
	targetNode,
	selectedCount,
	typeLabel,
	...rest
}) => {
	const title = `${COPY_SPECIFIC.EDITING} ${selectedCount} ${typeLabel}`;
	const okText = `${COPY_SPECIFIC.UPDATE} ${selectedCount} ${typeLabel}`;

	return (
		<DropdownModal
			className={ classNames('bulk-edit-modal', className) }
			fixedWidth
			getPopupContainer={ getPopupContainer }
			mask={ false }
			okButtonProps={ { disabled } }
			okText={ okText }
			targetNode={ targetNode }
			title={ title }
			wrapClassName='bulk-edit-modal-wrapper'
			{ ...rest }>
			{ children }
		</DropdownModal>
	);
};
